import Axios from "axios";
// const baseURL = (process.env.REACT_APP_BASE_URL || "https://test-app-env.eba-zzht2t5i.us-east-1.elasticbeanstalk.com/api/v1/api/v1/").replace(/\/+$/, '') // Remove trailing slash
// const baseURL = "https://test.api.farmerkonect.com/api/v1/"
// const baseURL = "https://prime-goshawk-boss.ngrok-free.app/api/v1/"
const baseURL = process.env.REACT_APP_BASE_URL

const normalizeApiRequestUrl = (url) => {
  if (!url || typeof url !== 'string') return url

  const trimmed = url.trim()
  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }

  try {
    const parsed = new URL(trimmed)

    if (baseURL) {
      const base = new URL(baseURL)
      const basePath = base.pathname.replace(/\/$/, '')

      if (parsed.pathname.startsWith(basePath)) {
        const relativePath = parsed.pathname.slice(basePath.length).replace(/^\//, '')
        return `${relativePath}${parsed.search}`
      }

      const apiVersionMatch = parsed.pathname.match(/\/api\/v\d+\/(.*)$/)
      if (apiVersionMatch?.[1]) {
        return `${apiVersionMatch[1]}${parsed.search}`
      }

      if (base.protocol === 'https:' && parsed.protocol === 'http:') {
        parsed.protocol = 'https:'
        return parsed.toString()
      }
    }

    if (parsed.protocol === 'http:' && typeof window !== 'undefined' && window.location.protocol === 'https:') {
      parsed.protocol = 'https:'
      return parsed.toString()
    }
  } catch {
    return trimmed.replace(/^http:\/\//i, 'https://')
  }

  return trimmed
}

const PUBLIC_AUTH_PATHS = [
  'auth/password/',
  'auth/login/',
  'auth/signup/',
  'auth/register/',
  'auth/2fa/',
]

const getStoredToken = () => {
  const token = localStorage.getItem('token')
  if (!token || token === 'null' || token === 'undefined') return null
  return token
}

const hasActiveSession = () => Boolean(getStoredToken())

const isPublicAuthRequest = (config) => {
  const url = config?.url || ''
  return PUBLIC_AUTH_PATHS.some((path) => url.includes(path))
}

const api = Axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (config.url) {
      config.url = normalizeApiRequestUrl(config.url)
    }

    const token = getStoredToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      delete config.headers.Authorization
    }
    return config;
  },
  (error) => {
    // if (process.env.NODE_ENV === "development") {
    //   console.error('Request Error:', error)
    // }
    return Promise.reject(error)
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Log the response for debugging (only in development)
    // if (process.env.NODE_ENV === "development") {
    // }
    return response;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      // if (process.env.NODE_ENV === "development") {
      //   console.error('Request timeout')
      // }
      return Promise.reject(new Error('Request timeout. Please try again.'));
    }

    if (!error.response) {
      // if (process.env.NODE_ENV === "development") {
      //   console.error('Network Error:', error)
      // }
      return Promise.reject(new Error('Network error. Please check your internet connection. ' + (error.message || '')));
    }

    const isTokenInvalid =
      error.response?.data?.code === 'token_not_valid' ||
      error.response?.data?.detail === 'Given token not valid for any token type'

    // Only show session-expired for logged-in users on protected requests
    if (isTokenInvalid && hasActiveSession() && !isPublicAuthRequest(error.config)) {
      window.dispatchEvent(new Event('session-expired'));
    }

    return Promise.reject(error);
  }
);

export const fetcher = (url) => api.get(url).then(res => res.data)

/**
 * Recursively fetches all pages of a paginated resource.
 * @param {string} url - The initial relative URL or absolute URL.
 * @returns {Promise<Array>} - A Promise that resolves to a flat array of all results.
 */
export const fetchAll = async (url) => {
  let allResults = []
  let nextUrl = url

  while (nextUrl) {
    const data = await api.get(nextUrl).then(res => res.data)
    
    // Check if response is paginated (has results array)
    if (data && Array.isArray(data.results)) {
      allResults = [...allResults, ...data.results]
      
      // Follow pagination using the configured API base URL, not backend http links.
      nextUrl = normalizeApiRequestUrl(data.next)
    } else {
      // If it's not a paginated response, return the data as-is or wrapped in an array
      return Array.isArray(data) ? data : (data ? [data] : [])
    }
  }

  return allResults
}

export default api;

export const BASE_URL = baseURL;
